
import { HistoryState, Load, ContinuousHistory, BatchHistory, History } from './state'

export const setContinuousHistoryItems = function (state: HistoryState, continuousHistory: ContinuousHistory[]): void {
  state.item.cck = continuousHistory
}

export const setBatchItems = function (state: HistoryState, batchHistory: BatchHistory[]): void {
  state.item.batch = batchHistory
}

export const setHistoryItems = function (state: HistoryState, history: History[]): void {
  state.item.check = history
}

export const setItems = function (state: HistoryState, { table, value }: { table: string; value: History[] | BatchHistory[] | ContinuousHistory[];}): void {
  if (!(table in state.item)) {
    return
  }

  switch (table) {
    case 'check': {
      setHistoryItems(state, value as History[])
      break
    }
    case 'batch': {
      setBatchItems(state, value as BatchHistory[])
      break
    }
    case 'cck': {
      setContinuousHistoryItems(state, value as ContinuousHistory[])
      break
    }
  }
}

export const setLoad = function (state: HistoryState, { table, value }: { table: string; value: boolean;}): void {
  if (!(table in state.load)) {
    return
  }

  state.load[table as keyof Load] = value
}
